import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { default as Header } from 'app/header'
import { useIsChangingSection } from 'shared/lib/hooks'
import { default as Spinner } from 'shared/ui/spinner'
import Footer from './footer'

function SuspenseFallback() {
  return (
    <div className="m-auto py-8">
      <Spinner />
    </div>
  )
}

export default function LandingLayout() {
  // Navigating from a landing page to a blocking data route (e.g. Browse) keeps
  // this layout mounted until the new loaders resolve; show the spinner the
  // moment that navigation starts. See useIsChangingSection.
  const isChangingSection = useIsChangingSection()

  return (
    <div className="flex min-h-screen flex-col">
      <Header />

      <main className="flex flex-grow flex-col">
        {isChangingSection ? (
          <SuspenseFallback />
        ) : (
          <Suspense fallback={<SuspenseFallback />}>
            <Outlet />
          </Suspense>
        )}
      </main>

      <Footer />
    </div>
  )
}
